import { useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { MdManageSearch } from 'react-icons/md';
import { FaCheckCircle } from 'react-icons/fa';
import { EditIcon } from '@chakra-ui/icons';
import ActionMenu from 'components/presentational/ActionMenu';

// Separate component for action cellRenderer to avoid dependency on darkMode in column definitions
const ActionCellRenderer = ({
    data,
    currentScope,
    general,
    handleEdit,
    handleApproval,
    handleManage,
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    const canApprove = data.approved === false;
    const canManage = currentScope !== 80;

    const actionItems = [
        {
            label: 'Edit',
            onClick: () => handleEdit({ data }),
            icon: EditIcon,
            dataAttributes: {
                'data-walkthroughid': `${general.ufEditButton}/${data.id}`,
            },
        },
    ];

    if (canManage) {
        actionItems.push({
            label: 'Manage',
            onClick: () => handleManage({ data }),
            icon: MdManageSearch,
            dataAttributes: {
                'data-walkthroughid': `${general.ufManageButton}/${data.id}`,
            },
        });
    }

    if (canApprove) {
        actionItems.push({
            label: 'Approve',
            onClick: () => handleApproval({ data }),
            icon: FaCheckCircle,
        });
    }

    // If only one action (Edit), show direct icon button
    if (actionItems.length === 1) {
        return (
            <Tooltip label="Edit Company">
                <IconButton
                    icon={
                        <BsThreeDotsVertical
                            fill={darkMode ? 'white' : 'black'}
                        />
                    }
                    aria-label="Edit"
                    variant="ghost"
                    onClick={() => handleEdit({ data })}
                    data-walkthroughid={`${general.ufEditButton}/${data.id}`}
                    _hover={{
                        bg: darkMode ? 'whiteAlpha.200' : 'blackAlpha.100',
                    }}
                    _active={{
                        bg: darkMode ? 'whiteAlpha.300' : 'blackAlpha.200',
                    }}
                    _focus={{ boxShadow: 'none' }}
                />
            </Tooltip>
        );
    }

    return <ActionMenu actionItems={actionItems} />;
};

export default ActionCellRenderer;
